var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 26.5H36.745L41.605 21.64L39.49 19.51L32.5 26.5H29.5V23.5L36.49 16.51L34.36 14.395L29.5 19.255V13H26.5V19.255L21.64 14.395L19.51 16.51L26.5 23.5V26.5H23.5L16.51 19.51L14.395 21.64L19.255 26.5H13V29.5H19.255L14.395 34.36L16.51 36.49L23.5 29.5H26.5V32.5L19.51 39.49L21.64 41.605L26.5 36.745V43H29.5V36.745L34.36 41.605L36.49 39.49L29.5 32.5V29.5H32.5L39.49 36.49L41.605 34.36L36.745 29.5H43V26.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAc);
export default __webpack_public_path__ + "static/media/ac.3aa1638344ea154621c6e4d4e94a0a42.svg";
export { ForwardRef as ReactComponent };